<script>
import { mapActions, mapGetters } from 'vuex'
import table from './offer-groups.table'
import getExportedFilename from '@lib/utils/get-exported-filename'

export default {
  name: 'OfferGroups',
  page: {
    title: 'Offer Groups',
  },
  data() {
    return {
      table: null,
    }
  },
  computed: {
    ...mapGetters('me', [
      'canCreateOffer',
    ]),
    customComparisons() {
      return {
        string: {
          eq: 'contains',
        },
      }
    },
  },
  async created() {
    this.setDefaultOfferGroup()
    this.table = table(this)
  },
  methods: {
    ...mapActions('offerGroup', [
      'setDefaultOfferGroup',
    ]),

    onRowClick(row) {
      this.$router.push({
        name: 'offer-group-details',
        params: { id: row.id },
      })
    },

    getExportedFilename() {
      return getExportedFilename(this.table.tableName)
    },

    handleClick() {
      this.$router.push({
        name: 'offer-group-create',
      })
    },
  },
}
</script>

<template>
  <main-layout title="Offer Groups">
    <template #header>
      <el-button
        v-if="canCreateOffer"
        type="primary"
        icon="el-icon-plus"
        plain
        @click="handleClick"
      >
        Add New Offer Group
      </el-button>
    </template>
    <table-layout
      :table-name="table.tableName"
      :processor="table.processor"
      :filters="table.filters"
      :initial-filters="$route.params.filters"
      :columns="table.columns"
      :fragments="false"
      :quantity="[25, 50, 100, 200]"
      :export-filename="getExportedFilename"
      :custom-comparisons="customComparisons"
      :multisort="false"
      hider-header-visible
      @row-click="onRowClick"
    />
  </main-layout>
</template>
